const ROLE_COLORS = ['cyan', 'indigo', 'pink', 'lime', 'yellow'];

export function hashRoleColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  }
  return ROLE_COLORS[hash % ROLE_COLORS.length];
}
